import { NavLink } from 'react-router';
import { Icone, Kbd, type NomeIcone } from '../ui';
import { useBusca } from './busca';
import css from './LayoutPainel.module.css';
import { useFilaDaMoldura } from './LinhaDeEstado';
import { AssinaturaDoSistema, LojaNoCelular, LojaNoMenu } from './LojaNoTopo';

// Menu do painel (quadro do balcão): no computador, coluna de 232 px com a loja em destaque (logo e nome),
// "Buscar /", as quatro áreas e, no pé, "Atalhos ?" e a assinatura "por entreguecerto"; no celular e na meia tela, as mesmas quatro, com os mesmos nomes, na
// barra de baixo. Sair e tema ficam em Configurações (fora do alcance de um clique sem querer).

const ITENS: { para: string; rotulo: string; icone: NomeIcone }[] = [
  { para: '/pedidos', rotulo: 'Pedidos', icone: 'pedidos' },
  { para: '/clientes', rotulo: 'Clientes', icone: 'clientes' },
  { para: '/entregadores', rotulo: 'Entregadores', icone: 'entregadores' },
  { para: '/configuracoes', rotulo: 'Configurações', icone: 'configuracoes' },
];

export function MenuLateral({ aoAbrirAtalhos }: { aoAbrirAtalhos: () => void }) {
  const busca = useBusca();
  const { fila } = useFilaDaMoldura();
  const paraSair = fila?.paraSair.length ?? 0;

  return (
    <nav className={css.menu} aria-label="Menu principal">
      <LojaNoMenu />
      <button type="button" className={css.buscar} onClick={busca.abrir} aria-keyshortcuts="/">
        <Icone nome="busca" tamanho={16} />
        Buscar
        <Kbd aria-hidden="true">/</Kbd>
      </button>
      <div className={css.itens}>
        {ITENS.map((item) => (
          <NavLink
            key={item.para}
            to={item.para}
            className={({ isActive }) =>
              [css.item, isActive && css.ativo].filter(Boolean).join(' ')
            }
          >
            <Icone nome={item.icone} tamanho={18} />
            <span className={css.rotuloItem}>{item.rotulo}</span>
            {item.para === '/pedidos' && paraSair > 0 && (
              <em className={css.contagem}>{paraSair} para sair</em>
            )}
          </NavLink>
        ))}
      </div>
      <div className={css.pe}>
        <button
          type="button"
          className={css.atalhos}
          onClick={aoAbrirAtalhos}
          aria-keyshortcuts="?"
        >
          Atalhos
          <Kbd aria-hidden="true">?</Kbd>
        </button>
        <AssinaturaDoSistema />
      </div>
    </nav>
  );
}

/** Topo do celular e da meia tela: a loja (logo e nome) e a lupa (a busca "/" por toque). */
export function TopoDoCelular() {
  const busca = useBusca();
  return (
    <header className={css.topoCelular}>
      <LojaNoCelular />
      <button type="button" className={css.lupa} aria-label="Buscar" onClick={busca.abrir}>
        <Icone nome="busca" tamanho={20} />
      </button>
    </header>
  );
}
